<template>
  <div>
    <div class="flex justify-between px-4 items-center mt-10">
      <h1 class="text-3xl font-bold text-center">{{ __("Conversations") }}</h1>
    </div>

    <div class="bg-white p-4 shadow-md mt-10 ">
      <table class="w-full" v-if="conversations.data.length">
        <tr class="bg-gray-700 text-gray-100">
          <th class="p-4 text-left">{{ __("Conversation") }}</th>
          <th class="p-4 text-left">{{ __("Received") }}</th>
        </tr>
        <tr v-for="(conversation, index) in conversations.data" :class="{'bg-gray-300': index%2 === 0}">
          <td class="p-4 flex items-center">
            <inertia-link class="hover:text-coral-400 flex" :href="route('conversations.show', {conversation: conversation.id})">
              <div class="h-12 w-12 mr-4">
                <img :src="conversation.last_message.author.avatar_url" :alt="conversation.last_message.author.name + ' profile image'" class="object-cover object-center"/>
              </div>
              <div class="flex flex-col">
                <div class="mb-2 font-bold flex items-center">
                  <div>{{ conversation.last_message.author.name }}</div>
                  <div class="inline-block bg-coral-400 h-4 w-4 ml-1 rounded-full" v-if="!conversation.last_message.read"></div>
                </div>
                <div>{{ conversation.last_message.body.substring(0, 50) }}...</div>
              </div>
            </inertia-link>
          </td>
          <td class="p-4">
            {{ conversation.last_message.created_at }}
          </td>
        </tr>
      </table>
      <div v-else>
        {{ __("No conversations at the moment...") }}
      </div>
    </div>

    <pagination :links="conversations.meta.links"/>
  </div>
</template>

<script>
  import Layout from '@/Shared/Layout';
  import Icon from '@/Shared/Icon';
  import Pagination from '@/Shared/Pagination';

  export default {
    layout: Layout,
    metaInfo() {
      return {
        title: 'Conversations'
      }
    },
    props: {
      conversations: Object,
    },
    components: {
      Layout,
      Pagination,
      Icon
    }
  }
</script>
